import clsx from 'clsx';
import { ContentLimiter, Show, Spacer } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import TabNavigation, { TabNavigationItem } from 'components/molecules/TabNavigation/TabNavigation';
import css from 'components/molecules/TabNavigation/TabNavigation.module.scss';
import { OTSAussendung } from 'components/profiles';
import React from 'react';
import { UnternehmenPlusDto } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';


interface AussendungenProps 
{
  unternehmen: UnternehmenPlusDto;
}

const Aussendungen: React.FC<AussendungenProps> = (props) =>
{
  const { unternehmen } = props;
  const { t } = useTranslation('profiles');
  const [activeYearIndex, setActiveYearIndex] = React.useState<number>(0);

  if (!unternehmen.otsAussendungen)
  {
    return null;
  }

  const years = unternehmen.otsAussendungen.reduce<string[]>((arr, curr) =>
  {
    const year = curr.datum.split('-')[0];
    if (arr.includes(year))
    {
      return arr;
    }
    return [...arr, year];
  }, []).sort((a, b) => b.localeCompare(a));

  const showNavigation = years.length > 1 && unternehmen.otsAussendungen.length > 3;

  const renderItem = (item: TabNavigationItem, index: number, isActive: boolean, setActiveItem: (index: number) => void): React.ReactElement =>
  {
    return (<div
      className={clsx(css.item, { [css.active]: isActive })}
      key={`tab-navigation-${item.href}`}>
      <button
        onClick={() => 
        {
          setActiveItem(index);
          setActiveYearIndex(index);
        }}
      >
        {item.text}
      </button>
    </div>);
  };

  return (
    <>

      {/* OTS Aussendungen */}
      <Show when={unternehmen.otsAussendungen.length > 0}>
        <ContentRow id="aussendungen" title={t('profiles:unternehmen.aussendungen.label')}>
          {showNavigation && (
            <div style={{ margin: '0 -1rem' }}><TabNavigation
              renderItem={renderItem}
              items={years.map((year) => ({ href: year, text: year }))} />
              <Spacer height={1}/>
            </div>)}
          <ul className="no-list-style">
            <ContentLimiter>
              {unternehmen.otsAussendungen.filter(a => !showNavigation || a.datum.startsWith(years[activeYearIndex])).sort((a, b) => b.datum.localeCompare(a.datum)).map((aussendung) => (
                <OTSAussendung key={aussendung.weblink} aussendung={aussendung} />
              ))}
            </ContentLimiter>
          </ul>
          
        </ContentRow>
      </Show>

    </>
  );
};

export default Aussendungen;
